export const INTERNAL = "internal" as const;
export const OPTUMID = "external" as const;
export const USER_TYPES = [INTERNAL, OPTUMID] as const;
export type UserType = typeof INTERNAL | typeof OPTUMID;

export interface BaseUser {
  optumName: string;
  id: number | null;
  status: string;
  sso: string;
  username: string;
  optumUUID: string;
  email: string;
  mpin: number | null;
  firstName: string;
  middleName: string | null;
  lastName: string;
  birthdate: string | null;
  gender: string | null;
  nickname: string | null;
  phone: string | null;
  emailVerified: boolean;
  type: 'internal' | 'external';
}

export interface NormalizedUser extends BaseUser {
  dashboardHideImAPhysician: boolean;
  dashboardHideGroupAdminAccess: boolean;
  dashboardHideDelegateAccess: boolean;
  dashboardHidePhysicianAccess: boolean;
  hasGroupReadPermission?: boolean;
  hasPhysicianReadPermission?: boolean;
  hasPhysicianWritePermission?: boolean;
  hasNotifPrepPermission?: boolean;
  isAuthenticated?: boolean;
}

export interface UserWithAccess extends NormalizedUser {
  pixeUserRelationships: {
    groupsAdministered: number[];
    physiciansAdministered: number[];
    physiciansDelegated: number[];
  };
  physiciansAdministered: Record<string, boolean>;
  physiciansDelegated: Record<string, boolean>;
  groupsAdministered: Record<string, boolean>;
}

export interface UserState {
  user: NormalizedUser | null;
  loading: boolean;
  error: string | null;
  isAuthenticated: boolean;
  showModalLogin: boolean;
}
